<div class="flex h-full min-h-0 flex-col">
  @if (isLoading) {
    <div class="flex flex-1 min-h-0 justify-center items-center">
      <mat-spinner />
    </div>
  } @else {
    <div class="flex flex-1 flex-col min-h-0 gap-2 overflow-y-auto py-2 px-1">
      @for (template of templates; track template.user_create_template_id) {
        <mat-card data-test-id="select-user-template-card">
          <mat-card-content class="bg-gray-50">
            <div class="flex flex-row justify-between items-center w-full">
              <div class="flex flex-col flex-1 gap-3">
                <p class="font-semibold" data-test-id="select-user-template-name">{{ template.type | userTemplate }}</p>
                <p data-test-id="select-user-template-allowed-applications">
                  Allowed applications: {{ getApplicationsList(template.applications) }}
                </p>
              </div>
              <button
                mat-flat-button
                color="primary"
                type="button"
                data-test-id="select-user-template-select"
                (click)="selectTemplate(template)"
              >
                Select
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      } @empty {
        <div class="flex flex-col justify-center items-center h-full" data-test-id="select-user-template-no-templates">
          <p>No templates</p>
        </div>
      }
    </div>
  }
</div>
